var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center"},[_c('img',{staticClass:"w-6",attrs:{"src":_vm.source.thumbsUp}}),_c('img',{staticClass:"w-6",attrs:{"src":_vm.source.thumbsDown}})])}
var staticRenderFns = []

export { render, staticRenderFns }